module.exports = __webpack_public_path__ + "static/media/404.ec4402e3.png";